
<template>
	<div id="app">
		<component :is="layout">
			<router-view />
		</component>
		<b-toaster name="toast-alertas-toaster" position="b-toaster-top-right" />
		<ToastAlertas />
	</div>
</template>

<script>
	import ToastAlertas from '@/components/Toast/ToastAlertas.vue';
	import { iniciarPopupAlertas, obtenerControladorPopup } from '@/helpers/popup.js';
	
	export default {
		components: { ToastAlertas },
		data() {
			return {
				popupControlador: null
			};
		},
		computed: {
			layout() { return "layout-" + (this.$route.meta.layout || "default") }
		},
		watch: {
			// ✅ Inicializar popup cuando el usuario se autentica
			'$store.state.auth'(newVal) {
				if (newVal && this.$store.state.user?.token && this.shouldShowPopups()) {
					this.inicializarPopup();
				} else if (!newVal && this.popupControlador) {
					this.popupControlador.stop();
					this.popupControlador = null;
				}
			},
			// ✅ Detener popup en rutas de login
			'$route'(newRoute) {
				// console.log('🔄 [App] Cambio de ruta a:', newRoute.path, 'Permitir popups:', this.shouldShowPopups());
				
				if (!this.shouldShowPopups()) {
					// Detener popup inmediatamente en páginas de login
					if (this.popupControlador) {
						// console.log('🚫 [App] Deteniendo popup por navegación a página de login');
						this.popupControlador.stop();
						this.popupControlador = null;
					}
				} else if (this.shouldShowPopups() && this.$store.state.auth && this.$store.state.user?.token) {
					// Inicializar popup solo si estamos en página válida y autenticados
					// console.log('✅ [App] Iniciando popup por navegación a página válida');
					this.inicializarPopup();
				}
			}
		},
		async mounted() {
			// ✅ Inicializar sistema de notificaciones globalmente
			try {
				// Inicializar notificaciones en el store
				await this.$store.dispatch('initNotifications');
				
				// ✅ Esperar un poco para que el store se estabilice
				setTimeout(() => {
					if (this.$store.state.auth && this.$store.state.user?.token && this.shouldShowPopups()) {
						this.inicializarPopup();
					}
				}, 1000);
				
			} catch (error) {
				console.error('Error inicializando sistemas:', error);
			}
		},
		beforeDestroy() {
			// ✅ Limpiar popup al destruir la app
			if (this.popupControlador) {
				this.popupControlador.stop();
				this.popupControlador = null;
			}
		},
		methods: {
			// ✅ Verificar si debemos mostrar popups según la ruta actual
			shouldShowPopups() {
				const rutasExcluidas = ['/sign-in', '/login', '/ingresar', '/recuperar-clave', '/reset-password', '/sign-up'];
				const rutaActual = this.$route.path.toLowerCase();
				return !rutasExcluidas.some(ruta => rutaActual.includes(ruta));
			},
			
			inicializarPopup() {
				// ✅ No inicializar en rutas de autenticación
				if (!this.shouldShowPopups()) {
					// console.log('🚫 [App] No inicializando popup - página no permitida');
					return;
				}
				// ✅ Verificar si ya existe un controlador
				const controladorExistente = obtenerControladorPopup();
				if (controladorExistente) {
					this.popupControlador = controladorExistente;
					
					// Reiniciar si no está activo pero debería estarlo
					const estado = this.popupControlador.estado;
					if (estado.autenticado && !estado.intervaloActivo) {
						this.popupControlador.start();
					}
					return;
				}

				// ✅ Crear nuevo controlador
				this.popupControlador = iniciarPopupAlertas(this.$store);
				
				if (this.popupControlador.estado.autenticado) {
					this.popupControlador.start();
				}
			}
		}
	}
	
</script>

<style lang="scss">
.b-toaster, .b-toaster .b-toaster__container {
  position: fixed !important;
  top: 1rem !important;
  right: 1rem !important;
  left: auto !important;
  width: auto !important;
  height: auto !important;
  z-index: 25000 !important;
  pointer-events: auto !important;
  overflow: visible !important;
}

.b-toast {
  position: relative !important;
  display: block !important;
  opacity: 1 !important;
  visibility: visible !important;
  transform: none !important;
  z-index: 25001 !important;
  max-width: 380px !important;
}
</style>